<template>
  <!-- Besoins exprimés -->
  <div class="h3">
    Vous nous avez par ailleurs déclaré :
  </div>

  <ul>
    <li>Je souhaite {{ user.typeGarantie === '1' ? "des Garanties complètes" : "un risque d'hospitalisation uniquement" }}.</li>
    <!-- Cas des retraités entre 55 et 80 ans -->
    <li v-if="user.displayObstetriqueOuOrthodontie">
      Je {{ user.besoinObstetrique !== '0' ? 'souhaite' : 'ne souhaite pas' }} une couverture obstétrique et {{ user.besoinOrthodontie !== '0' ? 'souhaite' : 'ne souhaite pas' }} une couverture orthodontie.
    </li>
    <li>Après avoir pris connaissance des différentes combinaisons de garanties possibles, je choisis la formule {{ user.libelleDuProduit }} {{ user.combinaison }} qui correspond à mes besoins pour une cotisation mensuelle TTC de {{ user.prix }}.</li>
  </ul>
</template>

<script>
export default {
  name: "RecapitulatifNeedsSante",
  props: {
    user: {
      type:Object,
      required: true
    }
  }
}
</script>

<style scoped>

</style>
